export interface OrderItemLog {
  orderReqItemLogId: number;
  username: string;
  action: string;
  datetime: string;
  previosPayload: string;
  newPayload: string;
}
